import { Reveal, MaskedLine } from "@/components/Reveal";

const PHRASES = [
  { text: "THE ARTIST.", color: "text-paper" },
  { text: "THE MISFIT.", color: "text-turq" },
  { text: "THE TROUBLEMAKER.", color: "text-paper" },
  { text: "THE SARCASTIC ONE.", color: "text-acid" },
  { text: "THE PERSON ASKING UNCOMFORTABLE QUESTIONS.", color: "text-paper" },
  { text: "THE PERSON WHO REFUSES TO CONFORM.", color: "text-pink" },
  { text: "THE PERSON WHO JUST WANTS TO BE THEMSELVES.", color: "text-paper" },
];

export default function WhoIsItFor() {
  return (
    <section data-testid="who-section" className="bg-black text-paper py-28 sm:py-40">
      <div className="mx-auto max-w-7xl px-5 sm:px-10">
        <Reveal>
          <p className="font-sans text-paper/50 text-xs font-semibold tracking-[0.35em] mb-3">05 — SHUTUP IS FOR...</p>
          <p className="font-hand text-acid text-2xl rotate-1 inline-block mb-9">the loud words are buttons. obviously.</p>
        </Reveal>

        <div className="space-y-3 sm:space-y-5">
          {PHRASES.map((p, i) => (
            <div
              key={p.text}
              style={{ marginLeft: `${(i % 3) * 4}%` }}
              data-sound={i % 2 ? "guitar" : "yelp"}
              data-cursor="shutup"
              className="hover:translate-x-3 transition-transform duration-300 w-fit"
            >
              <MaskedLine
                inView
                delay={0.05}
                className={`font-display ${p.color} ${
                  p.text.length > 30
                    ? "text-[clamp(1.5rem,4.6vw,4rem)]"
                    : "text-[clamp(2.4rem,7.5vw,6.5rem)]"
                } leading-[0.95]`}
              >
                {p.text}
              </MaskedLine>
            </div>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-20 text-right">
          <p className="font-hand text-pink text-4xl sm:text-6xl -rotate-2 inline-block" data-testid="who-closing">
            THIS ONE'S FOR YOU.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
